// Imperative toast API — call sites never touch React context directly.
// The dispatcher is registered by <ToastProvider> (src/components/ToastProvider.jsx)
// once at app root; until then, calls are dropped with a dev-only warning.

let dispatch = null;

export const _registerToastDispatcher = (fn) => {
  dispatch = fn;
};

const push = (type, title, detail, duration) => {
  if (!dispatch) {
    if (import.meta.env?.DEV) {
      console.warn(`[notify] ToastProvider not mounted yet — dropped toast: ${title}`);
    }
    return;
  }
  dispatch({ type, title, detail, duration });
};

const notify = {
  success: (title, detail) => push('success', title, detail, 4000),
  error: (title, detail) => push('error', title, detail, null),
};

export default notify;
